import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useGallery from './hooks/useGallery';
import SmallLoader from '@/src/Common/components/SmallLoader';

export default function SessionSharePage() {
    const { photoSessionId, galleryId } = useParams();
    const [gallery, setGallery] = useState<GalleryObject | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const { getGalleryById } = useGallery({
        slug: '',
        galleryId: Number(galleryId),
    });

    useEffect(() => {
        if (gallery?.baseUrl) {
            window.location.href = `${gallery.baseUrl}${window.location.pathname}`;
        }
    }, [gallery]);

    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            try {
                const galleryData = await getGalleryById();
                setGallery(galleryData);
            } catch (e) {
                console.error(e);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        load();
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [galleryId, photoSessionId]);

    if (isLoading) {
        return <SmallLoader />;
    }

    if (!gallery && !isLoading) {
        return (
            <div>
                <h3>Gallery not found...</h3>
            </div>
        );
    }

    return <SmallLoader />;
}
